import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    details: [],
    loading: false,
  },
  getters: {
    details: (state) => state.details,
    loading: (state) => state.loading,
  },
  actions: {
    fetchSingle({ commit }, id) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/OrdersQuery/" + id)
          .then((r) => {
            commit("setDetails", r.data);
            commit("setLoading", false);
            resolve(r.data);
            return r.data;
          })
          .catch((e) => reject(e));
      });
    },
    createOrder({ commit, dispatch }, id) {
      return ajax
        .post(
          "Sales/api/Orders",
          { checkOutForDraftOrderTransactionId: id },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    editOrder({ commit, dispatch }, model) {
      return ajax.put("Sales/api/Orders", model).then(() => {});
    },
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    },
    setLoading(state, value) {
      state.loading = value;
    },
  },
};
